import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useMemo } from 'react';
import { useContextMenuHandler } from '../../contextMenu/context/ContextMenuHandlerContext';
import { useIsCellVisible } from '../../virtualization/VirtualizationContext';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const Cell = ({
  CellComponent,
  columnIndex,
  rowIndex,
  columnNamespace,
  columnName,
  rowId,
  row,
  frozenColumnOffset,
  numberOfFrozenColumns = 0
}) => {
  const $theme = useTheme();
  const isCellVisible = useIsCellVisible({
    columnIndex,
    rowIndex
  });

  // HACK: These selectors are required for compatibility with onboarding tours
  // and coaching tips. When we've renamed the contact "name" column to it's
  // more permanent placeholder name, we should remove this and PR onboarding
  // tours/coaching tips to use the standardaized selectors.
  const onboardingSelectors = columnNamespace === CONTACT_TYPE_ID && ['name', 'email'].includes(columnName) ? {
    'data-onboarding': `contact-${columnName}-cell`
  } : {};

  // This id is part of our external api and should not be changed.
  // It will be used for features like coaching tips and onboarding tours.
  const externalId = `cell-${columnNamespace}-${columnName}-${rowId}`;
  const frozenColumnSelectors = useMemo(() => columnIndex < numberOfFrozenColumns ? {
    'data-frozen-column': true,
    style: {
      left: `${frozenColumnOffset}px`,
      borderRight: numberOfFrozenColumns - 1 === columnIndex ? `${$theme.borderWidth['300']} solid ${$theme.color['border-core-subtle']}` : `0.5px solid ${$theme.color['border-core-default']}`
    }
  } : {}, [columnIndex, frozenColumnOffset, numberOfFrozenColumns, $theme]);
  const handleContextMenu = useContextMenuHandler({
    row,
    columnName,
    columnNamespace
  });
  const requiredCellProps = Object.assign({
    'data-table-external-id': externalId,
    'data-test-id': externalId,
    onContextMenu: handleContextMenu
  }, onboardingSelectors, frozenColumnSelectors);
  if (!isCellVisible) {
    return /*#__PURE__*/_jsx("td", Object.assign({}, requiredCellProps));
  }
  return /*#__PURE__*/_jsx(CellComponent, {
    rowIndex: rowIndex,
    columnIndex: columnIndex,
    columnNamespace: columnNamespace,
    columnName: columnName,
    row: row,
    requiredCellProps: requiredCellProps
  });
};
export default Cell;